/* ==========================================================================
   SHOP — commerce controller + Blossom chrome (plain script → window.Shop)
   Owns cart/checkout/detail/sound/eggs and the HTML overlay.
   The 3D engine (window.GAL) calls Shop.showArt / openDetail / findEgg / tone.
   ========================================================================== */
(function(){
"use strict";
const ART=window.ART||[], COLL=window.COLLECTIONS||{};
const ART_BY_ID={}; ART.forEach(a=>ART_BY_ID[a.id]=a);
const ROOMS=window.ROOM3D||{}, ORDER=window.ROOM_ORDER||Object.keys(ROOMS);

/* ---- persistent state ---- */
const LS='salon3d_v2';
const DEF={ cart:[], eggs:[], sound:true, chromeDay:false, accent:'#2962FF', room:'forest', focus:{} };
let S=Object.assign({},DEF);
try{ const r=JSON.parse(localStorage.getItem(LS)); if(r) S=Object.assign({},DEF,r);}catch(e){}
function save(){ try{ localStorage.setItem(LS,JSON.stringify(S)); }catch(e){} }

let ENGINE=null;
const fmt=n=>'$'+n.toLocaleString('en-US');
const esc=s=>String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
/* ---- real Shopify product routing (id -> live product page) ----
   FLW-1            -> /products/flowers-flw-1
   IL-WHALE-GAMES   -> /products/impermanent-loss-il-whale-games
   TT-001           -> /products/transdimensional-trippers-001
   Each piece has a size+material variant picker on its product page. */
function productHandle(a){
  if(!a||!a.id) return null; const id=String(a.id);
  if(id.indexOf('FLW-')===0) return 'flowers-'+id.toLowerCase();
  if(id.indexOf('IL-')===0)  return 'impermanent-loss-il-'+id.replace(/^IL-/,'').toLowerCase();
  if(id.indexOf('TT-')===0)  return 'transdimensional-trippers-'+id.replace(/^TT-/,'');
  return null;
}
function productUrl(a){ const h=productHandle(a); return h?('/products/'+h):null; }
function goProduct(a){ const u=productUrl(a); if(u){ try{ window.location.assign(u); }catch(e){ window.location.href=u; } } }
function cartCount(){ return S.cart.reduce((s,c)=>s+c.qty,0); }
function cartTotal(){ return S.cart.reduce((s,c)=>{const a=ART_BY_ID[c.id];return s+(a?a.price*c.qty:0);},0); }
function inCart(id){ const c=S.cart.find(x=>x.id===id); return c?c.qty:0; }

/* ---- audio ---- */
let actx=null;
function ensureCtx(){ if(!actx){try{actx=new (window.AudioContext||window.webkitAudioContext)();}catch(e){}} if(actx&&actx.state==='suspended')actx.resume(); return actx; }
const NOTES={C:261.63,D:293.66,E:329.63,F:349.23,G:392,A:440,B:493.88,C2:523.25,D2:587.33,E2:659.25};
function tone(freq,dur,type,gain){
  if(!S.sound) return; const ctx=ensureCtx(); if(!ctx) return;
  dur=dur||.4; gain=gain==null?.14:gain;
  const o=ctx.createOscillator(),g=ctx.createGain();
  o.type=type||'sine'; o.frequency.value=freq; o.connect(g); g.connect(ctx.destination);
  const t=ctx.currentTime;
  g.gain.setValueAtTime(0,t); g.gain.linearRampToValueAtTime(gain,t+.012);
  g.gain.exponentialRampToValueAtTime(.0001,t+dur);
  o.start(t); o.stop(t+dur+.02);
}
function chord(freqs,dur,type){ (freqs||[]).forEach((f,i)=>setTimeout(()=>tone(f,dur||.5,type||'sine',.1),i*70)); }

/* ---- fx ---- */
function burst(xPct,yPct,n){
  const host=document.getElementById('fx-host'); if(!host) return;
  const cx=(xPct/100)*window.innerWidth, cy=(yPct/100)*window.innerHeight;
  const cols=[S.accent,'#3DFFC0','#ffffff','#0D0D0D','#FFB020']; n=n||28;
  for(let i=0;i<n;i++){
    const el=document.createElement('div'); el.className='confetti';
    el.style.background=cols[i%cols.length]; if(i%3===0) el.style.borderRadius='50%';
    host.appendChild(el);
    const ang=Math.random()*Math.PI*2, sp=120+Math.random()*260;
    const dx=Math.cos(ang)*sp, dy=Math.sin(ang)*sp-160;
    el.style.left=cx+'px'; el.style.top=cy+'px';
    el.animate([{transform:'translate(0,0) rotate(0)',opacity:1},
      {transform:`translate(${dx}px,${dy+340}px) rotate(${(Math.random()*720-360)|0}deg)`,opacity:0}],
      {duration:900+Math.random()*700,easing:'cubic-bezier(.2,.7,.3,1)'}).onfinish=()=>el.remove();
  }
}
function toast(msg,egg){
  const host=document.getElementById('toast-host'); if(!host) return;
  const t=document.createElement('div'); t.className='toast'+(egg?' egg':''); t.textContent=msg;
  host.appendChild(t);
  setTimeout(()=>{ t.style.transition='opacity .4s,transform .4s'; t.style.opacity='0'; t.style.transform='translateY(-8px)'; setTimeout(()=>t.remove(),420); }, egg?2800:1900);
}
function findEgg(roomId,msg){
  if(!S.eggs.includes(roomId)){ S.eggs.push(roomId); save(); updateEggBadge();
    toast('Easter egg · '+msg,true); burst(50,52,46); chord([NOTES.C2,NOTES.E2,NOTES.G],.4,'triangle');
  } else toast(msg,true);
}

/* ==========================================================================
   CHROME
   ========================================================================== */
function updateTopbar(room){
  const r=ROOMS[room]; if(!r) return;
  const idx=ORDER.indexOf(room);
  document.querySelector('.rs-name').textContent=r.name;
  document.querySelector('.rs-count').textContent=String(idx+1).padStart(2,'0')+' / '+ORDER.length;
}
function showArt(a,roomArr,roomIdx){
  const bar=document.querySelector('.combar');
  if(!a){ bar.classList.add('hide'); return; } bar.classList.remove('hide');
  bar.querySelector('.eyebrow').innerHTML=esc(a.collName);
  bar.querySelector('.title').textContent=a.title;
  let dots=''; for(let i=0;i<(a.edition||10);i++) dots+='<i class="live"></i>';
  bar.querySelector('.eddots').innerHTML=dots;
  bar.querySelector('.edtxt').textContent='';
  bar.querySelector('.price').firstChild.textContent=fmt(a.price);
  const btn=bar.querySelector('.collect'), have=inCart(a.id), sold=have>=a.remaining;
  btn.disabled=sold; btn.querySelector('.lbl').textContent=sold?'Reserved out':(have?'Add another':'Collect');
  // stage chip
  const chip=document.querySelector('.stagechip');
  if(chip&&roomArr) chip.innerHTML='<span class="dot">&#9670;</span> '+esc(a.collName)+' &nbsp;·&nbsp; '+(roomIdx+1)+' / '+roomArr.length+' in room';
  Shop.currentArt=a; updateCartBadge();
}
function updateCartBadge(){ const n=cartCount(); document.querySelectorAll('.cart-badge').forEach(b=>b.textContent=n);
  const cb=document.querySelector('.cartbtn'); if(cb) cb.classList.toggle('has',n>0); }
function updateEggBadge(){ const b=document.querySelector('.egg-badge'); if(b) b.textContent=S.eggs.length+'/'+ORDER.length; }

/* ==========================================================================
   CART
   ========================================================================== */
function addToCart(id){
  const a=ART_BY_ID[id]; if(!a) return;
  const c=S.cart.find(x=>x.id===id);
  if(c){ if(c.qty<a.remaining) c.qty++; } else S.cart.push({id,qty:1});
  save(); renderCart(); updateCartBadge();
  if(Shop.currentArt&&Shop.currentArt.id===id) showArt(a);
  tone(NOTES.A,.18,'triangle',.12); toast('Added · '+a.title);
}
function setQty(id,q){
  const a=ART_BY_ID[id], c=S.cart.find(x=>x.id===id); if(!c) return;
  c.qty=Math.max(0,Math.min(q,a?a.remaining:q));
  if(c.qty<=0) S.cart=S.cart.filter(x=>x.id!==id);
  save(); renderCart(); updateCartBadge();
  if(Shop.currentArt) showArt(Shop.currentArt);
}
function renderCart(){
  const list=document.querySelector('.cart-items');
  if(!S.cart.length) list.innerHTML='<div class="cart-empty">Nothing collected yet.</div>';
  else list.innerHTML=S.cart.map(c=>{const a=ART_BY_ID[c.id]; if(!a) return '';
    return '<div class="citem"><img src="'+a.thumb+'" referrerpolicy="no-referrer" alt=""><div class="ci-b">'+
      '<div class="ci-t">'+esc(a.title)+'</div>'+
      '<div class="ci-c">'+esc(a.collName)+' · '+esc(a.id)+'</div>'+
      '<div class="ci-row"><div class="qty"><button data-dec="'+a.id+'">&minus;</button><span>'+c.qty+'</span><button data-inc="'+a.id+'">+</button></div>'+
      '<div class="ci-p">'+fmt(a.price*c.qty)+'</div></div>'+
      '<button class="rm" data-rm="'+a.id+'">Remove</button></div></div>';
  }).join('');
  document.querySelector('.cart-sub .v').textContent=fmt(cartTotal());
  document.querySelector('.cart-f .btn').disabled=!S.cart.length;
}
function openCart(){ document.querySelector('.cart').classList.add('open'); renderCart(); }
function closeCart(){ document.querySelector('.cart').classList.remove('open'); }

/* ==========================================================================
   DETAIL
   ========================================================================== */
function openDetail(a){
  if(!a) return;
  const m=document.getElementById('detail-modal'), coll=COLL[a.coll]||{}, room=ROOMS[a.room];
  const row=(k,v)=>'<div class="r"><span class="k">'+k+'</span><span class="v">'+esc(v)+'</span></div>';
  m.querySelector('.sheet').innerHTML=
    '<button class="x" data-close>&times;</button>'+
    '<div class="detail"><div class="img"><img src="'+a.full+'" referrerpolicy="no-referrer" alt="'+esc(a.title)+'"></div>'+
      '<div class="info"><div class="eyebrow">'+esc(a.collName)+'</div><h2>'+esc(a.title)+'</h2>'+
      '<p class="blurb">'+esc(coll.blurb||'')+'</p>'+
      '<div class="spec">'+row('Edition','Limited to 10 per format · signed & numbered · retired when sold out')+
      row('Medium','Archival pigment print · signed')+row('Provenance','On-chain · IPFS permanent')+
      row('Now showing',room?room.name:'The Salon')+row('Reference',a.id)+'</div>'+
      '<div class="buy">'+
      '<a class="btn" href="'+(productUrl(a)||'#')+'"><span class="ph">&#9670;</span> Choose size &amp; collect</a></div></div></div>';
  m.classList.add('open');
}
function closeDetail(){ document.getElementById('detail-modal').classList.remove('open'); }

/* ==========================================================================
   CHECKOUT
   ========================================================================== */
function openCheckout(){
  if(!S.cart.length) return; closeCart();
  const m=document.getElementById('checkout-modal');
  const lines=S.cart.map(c=>{const a=ART_BY_ID[c.id];return '<div class="line"><span>'+esc(a.title)+' ×'+c.qty+'</span><span>'+fmt(a.price*c.qty)+'</span></div>';}).join('');
  m.querySelector('.sheet').innerHTML=
    '<button class="x" data-close>&times;</button><div class="checkout">'+
    '<h2>Checkout</h2><div class="sub">Secure · powered by the salon</div>'+
    '<div class="field"><label>Email</label><input type="email" placeholder="you@domain.xyz"></div>'+
    '<div class="field"><label>Card number</label><input placeholder="4242 4242 4242 4242"></div>'+
    '<div class="field-row"><div class="field"><label>Expiry</label><input placeholder="04 / 28"></div>'+
    '<div class="field"><label>CVC</label><input placeholder="123"></div></div>'+
    '<div style="margin:18px 0 6px">'+lines+
    '<div class="line"><span>Shipping</span><span>Free · worldwide</span></div>'+
    '<div class="line tot"><span>Total</span><span class="v">'+fmt(cartTotal())+'</span></div></div>'+
    '<button class="btn pay" data-pay><span class="ph">&#9670;</span> Pay '+fmt(cartTotal())+'</button>'+
    '<div class="paywash"><div class="spin"></div><div class="sm">Inscribing your collection…</div></div></div>';
  m.classList.add('open');
}
function doPay(){
  const wash=document.querySelector('#checkout-modal .paywash'); wash.classList.add('show');
  chord([NOTES.C,NOTES.E,NOTES.G],.3,'sine');
  setTimeout(()=>{
    wash.innerHTML='<div class="big">Inscribed.</div><div class="sm">Your editions are reserved. A receipt and shipping details are on the way. Thank you for collecting.</div><button class="btn" data-close style="margin-top:6px">Back to the salon</button>';
    burst(50,42,80); chord([NOTES.C2,NOTES.E2,NOTES.G],.5,'triangle');
    S.cart=[]; save(); updateCartBadge(); if(Shop.currentArt) showArt(Shop.currentArt);
  },1700);
}
function closeCheckout(){ document.getElementById('checkout-modal').classList.remove('open'); }

/* ==========================================================================
   ROOMS OVERLAY
   ========================================================================== */
const _thumbCache={};
function roomThumb(id,r){
  if(_thumbCache[id]) return _thumbCache[id];
  try{
    if(window.Backdrops && typeof window.Backdrops.paint==='function'){
      const cv=window.Backdrops.paint(id,r);
      if(cv && cv.toDataURL){ return (_thumbCache[id]=cv.toDataURL('image/jpeg',0.72)); }
    }
  }catch(e){}
  return (_thumbCache[id]='');
}
function buildRooms(){
  const grid=document.querySelector('.roomgrid');
  const byRoom={}; ART.forEach(a=>(byRoom[a.room]=byRoom[a.room]||[]).push(a));
  grid.innerHTML=ORDER.map(id=>{
    const r=ROOMS[id], arr=byRoom[id]||[], colls=[...new Set(arr.map(a=>a.collName))];
    const thumb=roomThumb(id,r);
    const miniBg=thumb
      ? 'background-image:url('+thumb+');background-size:cover;background-position:center'
      : 'background:linear-gradient(160deg,'+r.wall+','+shade(r.wall,-18)+')';
    return '<div class="roomcard'+(id===S.room?' active':'')+'" data-room="'+id+'" style="--rc1:'+r.wall+';--rc2:'+(r.accent)+'">'+
      '<div class="mini" style="'+miniBg+'">'+
        '<span class="mini-egg" style="color:'+r.accent+'">&#9670;</span></div>'+
      '<div class="cap"><div class="n">'+esc(r.name)+'</div>'+
      '<div class="c"><b>'+arr.length+' works</b> · '+esc(colls.join(' · '))+'</div></div></div>';
  }).join('');
  document.querySelector('.eggs-found').textContent=S.eggs.length+' / '+ORDER.length+' easter eggs found';
}
function shade(hex,p){ const n=parseInt(hex.slice(1),16); let r=(n>>16)&255,g=(n>>8)&255,b=n&255; const f=v=>Math.max(0,Math.min(255,Math.round(v+v*p/100))); return '#'+[f(r),f(g),f(b)].map(v=>v.toString(16).padStart(2,'0')).join(''); }
function openRooms(){ buildRooms(); document.getElementById('rooms-overlay').classList.add('open'); }
function closeRooms(){ document.getElementById('rooms-overlay').classList.remove('open'); }

/* ==========================================================================
   THEME / TWEAKS
   ========================================================================== */
function applyChrome(){
  const app=document.getElementById('app');
  app.classList.toggle('chrome-day',!!S.chromeDay);
  document.documentElement.classList.toggle('chrome-day',!!S.chromeDay);
  document.documentElement.style.setProperty('--salon-accent',S.accent);
  app.style.setProperty('--salon-accent',S.accent);
  const sb=document.querySelector('.sound-btn'); if(sb){ sb.classList.toggle('on',S.sound); sb.querySelector('.ph').innerHTML=S.sound?'&#9835;':'&#9834;'; }
}

/* ==========================================================================
   WIRING
   ========================================================================== */
function bind(){
  document.querySelector('.brand').onclick=openRooms;
  document.querySelector('.roomswitch').onclick=openRooms;
  document.querySelector('.rooms-btn').onclick=openRooms;
  document.getElementById('rooms-overlay').addEventListener('click',e=>{
    if(e.target.closest('[data-close]')||e.target.id==='rooms-overlay') return closeRooms();
    const c=e.target.closest('[data-room]'); if(c&&ENGINE){ ENGINE.goRoom(c.dataset.room); closeRooms(); }
  });
  document.querySelector('.artnav.prev').onclick=()=>ENGINE&&ENGINE.step(-1);
  document.querySelector('.artnav.next').onclick=()=>ENGINE&&ENGINE.step(1);
  document.querySelector('.collect').onclick=()=>{ if(Shop.currentArt) goProduct(Shop.currentArt); };
  document.querySelector('.combar .viewbtn').onclick=()=>openDetail(Shop.currentArt);
  document.querySelector('.cartbtn').onclick=openCart;
  document.querySelector('.cart .x').onclick=closeCart;
  document.querySelector('.cart-f .btn').onclick=openCheckout;
  document.querySelector('.cart-items').addEventListener('click',e=>{
    const inc=e.target.dataset.inc,dec=e.target.dataset.dec,rm=e.target.dataset.rm;
    if(inc) setQty(inc,inCart(inc)+1); if(dec) setQty(dec,inCart(dec)-1); if(rm) setQty(rm,0);
  });
  document.getElementById('detail-modal').addEventListener('click',e=>{
    if(e.target.closest('[data-close]')||e.target.id==='detail-modal') return closeDetail();
    const add=e.target.closest('[data-add]'); if(add){ addToCart(add.dataset.add); closeDetail(); openCart(); }
  });
  document.getElementById('checkout-modal').addEventListener('click',e=>{
    if(e.target.closest('[data-close]')||e.target.id==='checkout-modal') return closeCheckout();
    if(e.target.closest('[data-pay]')) doPay();
  });
  document.querySelector('.sound-btn').onclick=()=>{ S.sound=!S.sound; save(); applyChrome(); if(S.sound){ ensureCtx(); tone(NOTES.G,.2,'sine',.1);} };
  window.addEventListener('keydown',e=>{
    if(e.key==='Escape'){ closeDetail();closeCheckout();closeRooms();closeCart(); }
    // [ and ] step between artworks; arrows/WASD are used for walking
    else if(e.key===']'&&ENGINE) ENGINE.step(1);
    else if(e.key==='['&&ENGINE) ENGINE.step(-1);
  });
  window.addEventListener('pointerdown',()=>ensureCtx(),{once:true});
}

/* ---- public API ---- */
window.Shop={
  state:S, NOTES, tone, chord, burst, toast, findEgg, fmt,
  ensureCtx, save, currentArt:null,
  ART_BY_ID, esc,
  productHandle, productUrl, goProduct,
  addToCart, openCart, closeCart, COLL,
  showArt, openDetail, updateTopbar, updateCartBadge, updateEggBadge, applyChrome,
  bindEngine(g){ ENGINE=g; },
  setTweak(k,v){
    if(k==='chromeDay') S.chromeDay=v; if(k==='accent') S.accent=v; if(k==='sound') S.sound=v;
    save(); applyChrome();
    if(k==='accent'&&Shop.currentArt) showArt(Shop.currentArt);
    if((k==='accent'||k==='chromeDay')&&ENGINE) ENGINE.onTheme&&ENGINE.onTheme();
  },
  boot(){ applyChrome(); bind(); updateEggBadge(); }
};
// SALON alias for tweaks.js compatibility
window.SALON={ setTweak:(k,v)=>Shop.setTweak(k,v), get state(){return S;} };
})();